export enum DocStatus {
	InActive = 0,
	Active,
}
